var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1090",
    d: "M3 11.282L3 2.67822L5 2.67822L5 11.282H3Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M0.548828 4.91822L3.99974 1.67822L7.45066 4.91822",
    stroke: "#CCCCCC",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingArrow);
export default __webpack_public_path__ + "static/media/loading-arrow.2b0282052cdd8b216bdfac5338ab9520.svg";
export { ForwardRef as ReactComponent };